import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountProfileChangeComponent } from './account-profile-change.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AccountProfileChangeComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    TranslateModule
  ],
  exports: [AccountProfileChangeComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],

})
export class AccountProfileChangeModule {}
